import { useState } from 'react';
import { View } from 'react-native';

import { LorentzLoginScreen } from './LorentzLoginScreen';
import { CtiActionsBar } from './CtiActionsBar';
import { CtiTransferModal } from './CtiTransferModal';
import { QualificationModal } from './QualificationModal';
import { ScreenPopPanel } from './ScreenPopPanel';
import { PauseReasonModal } from './PauseReasonModal';
import { PauseExceededAlert } from './PauseExceededAlert';
import { SupervisorPanels } from './SupervisorPanels';
import { PredictiveStatus } from './PredictiveStatus';
import { ExtensionStatusBar } from './ExtensionStatusBar';
import { useStore } from '../../store/Context';
import { isPanelEnabled } from '../../utils/viewLayout';

export { LorentzLoginScreen };
export { QueueBadge } from './QueueBadge';

/**
 * Overlays e barra CTI Lorentz (Fase 1 + Fase 2 + Fase 3).
 */
export const LorentzOverlay = () => {
  const [transferOpen, setTransferOpen] = useState(false);

  return (
    <>
      <QualificationModal />
      <ScreenPopPanel />
      <PauseReasonModal />
      <CtiTransferModal
        visible={transferOpen}
        onClose={() => setTransferOpen(false)}
      />
    </>
  );
};

/** Barra de ações + alertas — renderizar na tela principal do Phone */
export const LorentzCtiPanel = () => {
  const [transferOpen, setTransferOpen] = useState(false);
  const { viewLayout } = useStore();

  return (
    <View>
      {isPanelEnabled(viewLayout, 'extensionStatusBar', true) ? (
        <ExtensionStatusBar />
      ) : null}
      {isPanelEnabled(viewLayout, 'predictiveStatus', true) ? (
        <PredictiveStatus />
      ) : null}
      <PauseExceededAlert />
      {isPanelEnabled(viewLayout, 'ctiPanel', true) ? (
        <CtiActionsBar onTransferClick={() => setTransferOpen(true)} />
      ) : null}
      {isPanelEnabled(viewLayout, 'supervisorPanels', false) ? (
        <SupervisorPanels />
      ) : null}
      <CtiTransferModal
        visible={transferOpen}
        onClose={() => setTransferOpen(false)}
      />
    </View>
  );
};

export default LorentzOverlay;
